// extracted by mini-css-extract-plugin
export var header = "header-module--header--aQ2aa";
export var title = "header-module--title--yZ4Os";
export var fadein = "header-module--fadein--DRC4H";